import { IHttpClient } from '@wix/http-client';

type RequestResponse<T> = T & { requestId: string };
export type UoUChatBusinessProperties = { businessName: string; assistantName: string; imageUrl?: string | null };
export type GetConversationTokenResponse = { token: string | null };

const BASE_URL = '/v1';

export class ChatHttpClient {
  constructor(private httpClient: IHttpClient) {}

  public async getBusinessProperties(): Promise<RequestResponse<UoUChatBusinessProperties>> {
    const url = `${BASE_URL}/business-properties`;
    const { data: businessProperties, requestId } = await this.httpClient.get<UoUChatBusinessProperties>(url);

    return { ...businessProperties, requestId };
  }

  public async getConversationToken(conversationId: string): Promise<RequestResponse<GetConversationTokenResponse>> {
    const url = `${BASE_URL}/conversations/${conversationId}/token`;
    const { data, requestId } = await this.httpClient.get<GetConversationTokenResponse>(url);

    return { ...data, requestId };
  }

  public async isConversationError(conversationId: string): Promise<RequestResponse<{ isError: boolean }>> {
    const url = `${BASE_URL}/is-conversation-error?conversationId=${conversationId}`;
    const { data, requestId } = await this.httpClient.get<{ isError: boolean }>(url);

    return { ...data, requestId };
  }
}
